import * as echarts from 'echarts'
import dayjs from 'dayjs'

const $str = window.$str;

const chartColors = ['#4960FF', '#0CD5FF', '#2DFFAA', '#FFA441', '#944DFF', '#EE3CD3', '#FF532D', '#0DE24A']
const lineColor = "#3e4961"; // 图表splitLine的颜色
const textColor = "#8b93aa"; // 图表文字的颜色

const defaultMin = dayjs().format('YYYY-MM-DD 00:00:00');
const defaultMax = dayjs().format('YYYY-MM-DD 23:59:59');


function getYaxisRange(heatData, powerData) {
  const result = {
    y1: {
      min: 0,
      max: 40
    },
    y2: {
      min: 0,
      max: 10
    },
    y3: {
      min: -90,
      max: 90
    },
    y4: {
      min: 0,
      max: 1
    },
  }
  if (Array.isArray(heatData) && heatData.length > 0) {
    // 温度
    const y1HasUsefullData = heatData.some(item => {
      if (!isNaN(Number(item.t_cell_max)) || !isNaN(Number(item.t_cell_min)) || !isNaN(Number(item.temp_ambient))) {
        return true;
      } else {
        return false;
      }
    })
    if (y1HasUsefullData) {
      result.y1.min = undefined;
      result.y1.max = undefined;
    }
    // 温度标准差
    const y2HasUsefullData = heatData.some(item => {
      if (!isNaN(Number(item.t_cell_std)) || !isNaN(Number(item.t_cell_std_25))) {
        return true;
      } else {
        return false;
      }
    })
    if (y2HasUsefullData) {
      result.y2.min = undefined;
      result.y2.max = undefined;
    }
    // 功率
    const y3HasUsefullData = powerData.some(item => {
      if (!isNaN(Number(item.pcspower_dc))) {
        return true;
      } else {
        return false;
      }
    })

    if (y3HasUsefullData) {
      result.y3.min = undefined;
      result.y3.max = undefined;
    }
    // 湿度
    const y4HasUsefullData = heatData.some(item => {
      if (!isNaN(Number(item.hum_cabinet))) {
        return true;
      } else {
        return false;
      }
    })
    if (y4HasUsefullData) {
      result.y4.min = undefined;
      result.y4.max = undefined;
    }
  }


  if (Array.isArray(powerData) && powerData.length > 0) {
    // 功率
    const y3HasUsefullData = powerData.some(item => {
      if (!isNaN(Number(item.pcspower_dc))) {
        return true;
      } else {
        return false;
      }
    })
    if (y3HasUsefullData) {
      result.y3.min = undefined;
      result.y3.max = undefined;
    }
  }

  return result;
}


/** 获取eCharts配置对象 */
export function getChartOption(heatData = [], powerData = [], start = defaultMin, end = defaultMax) {
  const { y1, y2, y3, y4 } = getYaxisRange(heatData, powerData);

  const airConditionData = getAirConditionData(heatData); // 空调状态
  const cellMaxTemp = []; // 【电芯】最高温度
  const cellMinTemp = []; // [电芯]最低温度
  const cellTemperatureVariance = []; // 电芯温度标准差
  const cellTemperatureVarianceto25 = []; // 电芯温度25°标准差
  const cabinetAmbientTemperature = []; // 柜体环境温度
  const cabinetHumidity = []; // 柜体湿度
  const pcspower_dc = []; // PCS直流侧功率

  if (Array.isArray(heatData)) {
    heatData.map(elem => {
      const t = dayjs(elem.record_time).format("YYYY-MM-DD HH:mm:ss")
      cellMaxTemp.push([t, Number(elem.t_cell_max).toFixed(2)])
      cellMinTemp.push([t, Number(elem.t_cell_min).toFixed(2)])
      cellTemperatureVariance.push([t, Number(elem.t_cell_std).toFixed(2)])
      cellTemperatureVarianceto25.push([t, Number(elem.t_cell_std_25).toFixed(2)])
      cabinetAmbientTemperature.push([t, Number(elem.temp_ambient).toFixed(2)])
      cabinetHumidity.push([t, elem.hum_cabinet != null ? Number(elem.hum_cabinet).toFixed(2) : void 0])
    })
  }

  if (Array.isArray(powerData)) {
    powerData.map(elem => {
      const t = dayjs(elem.record_time).format("YYYY-MM-DD HH:mm:ss")
      pcspower_dc.push([t, Number(elem.pcspower_dc).toFixed(2)])
    })
  }

  const left = '5%'
  const right = 20
  const option = {
    color: chartColors,
    grid: [
      {
        top: '8%',
        left: left,
        right: right,
        height: '18%',
      },
      {
        top: '31%',
        left: left,
        right: right,
        height: '19%',
      },
      {
        top: '55%',
        left: left,
        right: right,
        height: '19%'
      },
      {
        top: '79%',
        left: left,
        right: right,
        height: '18%'
      }
    ],
    xAxis: [
      {
        show: false,
        gridIndex: 0,
        nameLocation: 'end',
        nameTextStyle: {
          color: textColor
        },
        type: 'time',
        min: start,
        max: end,
        axisLabel: {
          show: false,
          color: textColor,
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        axisPointer: {
          label: {
            show: false
          }
        }
      },
      {
        show: false,
        gridIndex: 1,
        nameLocation: 'end',
        nameTextStyle: {
          color: textColor
        },
        type: 'time',
        min: start,
        max: end,
        axisLabel: {
          show: false,
          color: textColor,
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        axisPointer: {
          label: {
            show: false
          }
        }
      },
      {
        show: false,
        gridIndex: 2,
        nameLocation: 'end',
        nameTextStyle: {
          color: textColor
        },
        type: 'time',
        min: start,
        max: end,
        axisLabel: {
          show: false,
          color: textColor,
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        axisPointer: {
          label: {
            show: false
          }
        }
      },
      {
        // show: false,
        gridIndex: 3,
        nameLocation: 'end',
        nameTextStyle: {
          color: textColor
        },
        type: 'time',
        min: start,
        max: end,
        axisLabel: {
          color: textColor,
          formatter(value) {
            return dayjs(value).format("YYYY-MM-DD HH:mm:ss").replace(/\s/, '\n');
          },
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        axisPointer: {
          label: {
            show: true, // 只在最后一个x轴显示时间标签
            backgroundColor: '#777'
          }
        }
      },
    ],
    yAxis: [
      {
        gridIndex: 0,
        name: $str.getKey('数据分析/温度(℃)'),
        nameLocation: 'middle',
        nameGap: 30,
        nameTextStyle: {
          align: 'center',
          color: textColor
        },
        type: 'value',
        splitLine: {
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        },
        axisLabel: {
          color: textColor,
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        min: y1.min,
        max: y1.max,
      },
      {
        gridIndex: 1,
        name: $str.getKey('数据分析/温度标准差(K)'),
        nameLocation: 'middle',
        nameGap: 30,
        nameTextStyle: {
          align: 'center',
          color: textColor
        },
        type: 'value',
        splitLine: {
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        },
        axisLabel: {
          color: textColor,
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        min: y2.min,
        max: y2.max,
      },
      {
        gridIndex: 2,
        name: $str.getKey('数据分析/功率(kW)'),
        nameLocation: 'middle',
        nameGap: 30,
        nameTextStyle: {
          align: 'center',
          color: textColor,
        },
        type: 'value',
        splitLine: {
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        },
        axisLabel: {
          color: textColor,
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        min: y3.min,
        max: y3.max,
      },
      {
        gridIndex: 3,
        name: $str.getKey('数据分析/湿度(%RH)'),
        nameLocation: 'middle',
        nameGap: 30,
        nameTextStyle: {
          align: 'center',
          color: textColor,
        },
        type: 'value',
        splitLine: {
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        },
        axisLabel: {
          color: textColor,
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        min: y4.min,
        max: y4.max,
      },
    ],
    tooltip: createTooltip(),
    axisPointer: {
      link: { xAxisIndex: 'all' },
      label: {
        backgroundColor: '#777'
      }
    },
    legend: {
      show: true,
      top: 0, // 移动到顶部
      right: 10,
      // left: 'center',
      icon: 'circle',
      itemWidth: 8,
      textStyle: {
        color: textColor
      }
    },
    series: [
      {
        name: $str.getKey('数据分析/空调状态'),
        type: 'line',
        xAxisIndex: 0,
        yAxisIndex: 0,
        markArea: {
          data: airConditionData,
          label: {
            show: true,
            offset: [0, 6] // [x偏移, y偏移]
          }
        },
      },
      {
        name: $str.getKey('数据分析/空调状态'),
        type: 'line',
        xAxisIndex: 1,
        yAxisIndex: 1,
        markArea: {
          data: airConditionData,
          label: {
            show: true,
            offset: [0, 6]
          }
        },
      },
      {
        name: $str.getKey('数据分析/空调状态'),
        type: 'line',
        xAxisIndex: 2,
        yAxisIndex: 2,
        markArea: {
          data: airConditionData,
          label: {
            show: true,
            offset: [0, 6]
          }
        },
      },
      {
        name: $str.getKey('数据分析/空调状态'),
        type: 'line',
        xAxisIndex: 3,
        yAxisIndex: 3,
        markArea: {
          data: airConditionData,
          label: {
            show: true,
            offset: [0, 6]
          }
        },
      },
      {
        name: $str.getKey('数据分析/最高温度'),
        data: cellMaxTemp,
        type: 'line',
        xAxisIndex: 0,
        yAxisIndex: 0,
        // smooth: true,
        symbol: 'circle',
        symbolSize: 5,
        lineStyle: {
          width: 1
        },
        // areaStyle: {
        //   color: {
        //     type: 'linear',
        //     x: 0,
        //     y: 0,
        //     x2: 0,
        //     y2: 1,
        //     colorStops: [{
        //       offset: 1, color: 'rgba(19, 58, 255, 0.04)' // 0% 处的颜色
        //     }, {
        //       offset: 0, color: 'rgba(9, 170, 251, 0.4)' // 100% 处的颜色
        //     }],
        //     global: false // 缺省为 false
        //   }
        // }
      },
      {
        name: $str.getKey('数据分析/最低温度'),
        // data: [0, 10, 20, 30, 40, 50, 50, 50, 50, 50, 40, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
        data: cellMinTemp,
        type: 'line',
        xAxisIndex: 0,
        yAxisIndex: 0,
        // smooth: true,
        symbol: 'circle',
        symbolSize: 5,
        lineStyle: {
          width: 1
        },

      },
      {
        name: $str.getKey('数据分析/柜体温度'),
        // data: [0, 5, 10, 15, 20, 25, 25, 25, 25, 25, 20, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15],
        data: cabinetAmbientTemperature,
        type: 'line',
        xAxisIndex: 0,
        yAxisIndex: 0,
        // smooth: true,
        symbol: 'circle',
        symbolSize: 5,
        lineStyle: {
          width: 1
        },

      },
      {
        name: $str.getKey('数据分析/电芯温度标准差'),
        // data: Array.from({ length: 24 }, () => random(-40, 40)),
        // data: [0, 0.25, 0.24, 0.20, 0.10, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2, 0.1, 0.31],
        data: cellTemperatureVariance,
        type: 'line',
        xAxisIndex: 1,
        yAxisIndex: 1,
        // smooth: true,
        symbol: 'circle',
        symbolSize: 5,
        lineStyle: {
          width: 1
        },
        // areaStyle: {
        //   opacity: 0.2
        // },
        // markArea: {
        //   data: airConditionData,
        // }
      },
      {
        name: $str.getKey('数据分析/电芯温度25℃标准差'),
        // data: Array.from({ length: 24 }, () => random(-40, 40)),
        // data: [0, 2, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0.2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 1, 3, 0, 0],
        data: cellTemperatureVarianceto25,
        type: 'line',
        xAxisIndex: 1,
        yAxisIndex: 1,
        smooth: true,
        symbol: 'circle',
        symbolSize: 5,
        lineStyle: {
          width: 1
        },
        // areaStyle: {
        //   opacity: 0.2
        // },
      },
      {
        name: $str.getKey('数据分析/PCS直流侧功率'),
        data: pcspower_dc,
        type: 'line',
        xAxisIndex: 2,
        yAxisIndex: 2,
        smooth: true,
        symbol: 'circle',
        symbolSize: 0,
        lineStyle: {
          width: 2,
        },
        // areaStyle: {
        //   opacity: 0.2
        // },
      },

      {
        name: $str.getKey('数据分析/柜体湿度'),
        data: cabinetHumidity,
        type: 'line',
        xAxisIndex: 3,
        yAxisIndex: 3,
        smooth: true,
        symbol: 'circle',
        symbolSize: 0,
        lineStyle: {
          width: 2,
        },
        // areaStyle: {
        //   opacity: 0.2
        // },
      },

    ]
    // dataZoom: [{
    //   textStyle: {
    //     color: '#8392A5'
    //   },
    //   handleIcon: 'path://M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
    //   dataBackground: {
    //     areaStyle: {
    //       color: '#8392A5'
    //     },
    //     lineStyle: {
    //       opacity: 0.8,
    //       color: '#8392A5'
    //     }
    //   },
    //   brushSelect: true,
    //   start: 0,
    //   end: 100,
    //   xAxisIndex: [0, 1, 2, 3]
    // },
    // {
    //   type: 'inside',
    //   xAxisIndex: [0, 1, 2, 3]
    // }
    // ],
  }

  return option


}


/** 获取用于图表渲染的【空调状态】数据 */
function getAirConditionData(heatData) {
  if (!Array.isArray(heatData)) { return; }
  // 获取相同状态的连续区间
  let currState = -1;
  const stateRangeList = [];
  const len = heatData.length
  for (let i = 0; i < len; i++) {
    const stateRecordItem = {
      state: heatData[i]['state_ac'],
      time: heatData[i]['record_time']
    }
    if (stateRecordItem.state === currState && i !== 0) {
      const lastIdx = stateRangeList.length - 1;
      stateRangeList[lastIdx].push(stateRecordItem);
    } else {
      currState = stateRecordItem.state;
      stateRangeList.push([stateRecordItem]);
    }
  }

  // 封装方法：生成一个图表的区域数据
  const generateCharDataItem = (name, color, startAxis, endAxis) => {
    return [
      {
        itemStyle: {
          color: color
        },
        name: name,
        xAxis: startAxis
      },
      {
        itemStyle: {
          color: echarts.color.modifyAlpha(color, 0.1)
        },
        name: name,
        xAxis: endAxis
      }
    ];
  }

  // 根据状态，生成各区间的空调状态数据
  const chartData = [];
  stateRangeList.forEach(range => {
    if (range.length > 1) { // 一个点构成的range无效
      const start = range[0].time;
      const end = range.slice(-1)[0].time;
      // 制热
      if (range[0].state === 1) {
        const itemData = generateCharDataItem($str.getKey('数据分析/制热'), 'rgba(255, 128, 64, 0.3)', start, end)
        chartData.push(itemData);
      }
      // 制冷
      if (range[0].state === 2) {
        const itemData = generateCharDataItem($str.getKey('数据分析/制冷'), 'rgba(64, 128, 255, 0.3)', start, end)
        chartData.push(itemData);
      }
      // 故障
      if (range[0].state === 3) {
        const itemData = generateCharDataItem($str.getKey('数据分析/故障'), 'rgba(255, 0, 0, 0.2)', start, end)
        chartData.push(itemData);
      }
      // 除湿
      if (range[0].state === 4) {
        const itemData = generateCharDataItem($str.getKey('数据分析/除湿'), 'rgba(255, 128, 255, 0.2)', start, end)
        chartData.push(itemData);
      }
      if (range[0].state === 103) {
        const itemData = generateCharDataItem($str.getKey('数据分析/自循环'), 'rgba(128, 255, 128, 0.2)', start, end)
        chartData.push(itemData);
      }
    }
  });
  return chartData;
}




/** 创建Tooltip的配置对象 */
function createTooltip(config = {}) {
  const timeFormatter = (value) => {
    // 格式化时间：如果是时间戳，转换为年月日时分秒；如果是时间字符串，直接使用
    let timeValue = value;
    if (typeof timeValue === 'number' || (typeof timeValue === 'string' && /^\d+$/.test(timeValue))) {
      // 判断是否是时间戳（毫秒或秒）
      const timestamp = Number(timeValue);
      const isMillisecond = timestamp > 946684800000; // 2000-01-01的时间戳（毫秒）
      timeValue = dayjs(isMillisecond ? timestamp : timestamp * 1000).format('YYYY-MM-DD HH:mm:ss');
    } else if (timeValue instanceof Date) {
      timeValue = dayjs(timeValue).format('YYYY-MM-DD HH:mm:ss');
    } else if (typeof timeValue === 'string') {
      // 如果已经是时间字符串，尝试格式化
      timeValue = dayjs(timeValue).format('YYYY-MM-DD HH:mm:ss');
    }
    return timeValue;
  };

  return {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    className: 'chart-tooltip',
    backgroundColor: 'rgba(255, 255, 255, 0.90)',
    borderWidth: 0,
    textStyle: {
      color: '#6A727C'
    },
    formatter(params) {
      let time = params[0].axisValue;
      time = timeFormatter(time);

      const str = (list) => {
        let t = '';
        for (const item of list) {
          const originPrice = Array.isArray(item.data) ? item.data[1] : item.data;
          const price = formatPriceValueForShow(originPrice);
          t += /* html */`
            <div class="chart-tooltip__series" style="display: flex; align-items: center; justify-content: space-between; gap: 8px; line-height: 1.5;">
              <div style="display: flex; align-items: center; gap: 6px; flex: 1;">
                <div class="chart-tooltip__point" style="background: ${item.color}; width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; display: inline-block; vertical-align: middle;"></div>
                <div class="chart-tooltip__series-name" style="display: inline-block; vertical-align: middle;">${item.seriesName}</div>
              </div>
              <div class="chart-tooltip__value" style="flex-shrink: 0; display: inline-block; vertical-align: middle; text-align: right;">${price ?? '--'}</div>
            </div>`;
        }
        return t;
      };

      return /* html */`
        <div class="chart-tooltip__time" style="margin-bottom: 12px;">${time}</div>
        <div class="chart-tooltip__items-container">${str(params)}</div>
        `;
    }
  }
}

/** 格式化：价格展示时-只保留两位小数 */
function formatPriceValueForShow(price) {
  if (typeof (price) === 'number' && !isNaN(price)) {
    return (+price).toFixed(2);
  } else {
    return price
  }
}




